export class Request {

    static async send(url:string, data:object, callback = (arg:any)=>{}) {
        const formData = new FormData();
        for (let index in data) {
            formData.append(index, data[index]);
        }
        const response = await fetch(url, {
            method: 'POST',
            body: formData
        });
        const json = await response.json();
        callback(json);
        return json;
    }
}